<script setup lang="ts">
// Libraries and services import
import { computed, inject } from "vue";

import { useWorkerMissionActions } from "@/composables/missions/worker-actions/useWorkerActions";

import type { DropdownGeneratorAction } from "@/dsComponents/Dropdown/types";
// Data and type import
import type { MissionCommand } from '@/types/mission';

// Components import
import Button from "@/dsComponents/buttons/Button.vue";
import Dropdown from "@/dsComponents/Dropdown/Dropdown.vue";
import DropdownGenerator from "@/dsComponents/Dropdown/DropdownGenerator.vue";

interface WorkerActionsProps {
    availableActions: MissionCommand[];
}

const props = defineProps<WorkerActionsProps>();

const { workerActions } = useWorkerMissionActions();

const actionLoading = inject("actionLoading") as boolean;

const actions = computed<DropdownGeneratorAction[]>(() => {
    return workerActions(props.availableActions);
});
</script>

<template>
    <div class="worker-actions">
        <Dropdown width="200px" :closeOnDescendant="true">
            <template #trigger-zone>
                <Button class="button-dropdown" variant="ghost" type="neutral" size="xs" iconOnly="dots" :loading="actionLoading" />
            </template>
            <template #dropdown-content>
                <DropdownGenerator :actions="actions" />
            </template>
        </Dropdown>
    </div>
</template>
<style scoped lang="scss"></style>
